export default "__VITE_ASSET__D1QU3Bze__"